export enum CalendarTypeEnum {
  'Community Event',
  'Organizational Event',
  'Members Only',
  'Internal Event',
}
